import React, { useState } from "react";
import { Row, Col, Breadcrumb, Button, Dropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import { RiHome6Line } from "react-icons/ri";
import { MdKeyboardArrowRight } from "react-icons/md";
import { FiPlusCircle, FiFileText } from "react-icons/fi";
import { HiOutlineDocumentText } from "react-icons/hi2";
import AddDepartmentModal from "../../modals/hrm/employee/departments/AddDepartmentModal";

const DepartmentHeader = () => {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <div
        style={{
          // backgroundColor: "#f8f9fb",
          // padding: "16px 20px",
          borderBottom: "1px solid #e5e7eb",
        }}
      >
        <Row className="align-items-center  justify-content-between">
          {/* LEFT */}
          <Col md={4} sm={12}>
            <div className="my-auto mb-2">
              <h4 style={{ fontWeight: "600", marginBottom: "5px" }}>
                Departments
              </h4>

              <Breadcrumb
                style={{
                  background: "transparent",
                  padding: 0,
                  margin: 0,
                  fontSize: "14px",
                }}
              >
                <Breadcrumb.Item>
                  <Link to="/">
                    <RiHome6Line
                      className="m text-dark"
                      style={{
                        fontSize: "1.2rem", // increased icon size
                        verticalAlign: "middle",
                      }}
                    />
                  </Link>
                </Breadcrumb.Item>

                <MdKeyboardArrowRight className="mt-1 fs-5" />

                <Breadcrumb.Item
                  linkAs="span"
                  className="text-dark text-decoration-none fs-6"
                >
                  HRM
                </Breadcrumb.Item>

                <MdKeyboardArrowRight className="mt-1 fs-5" />

                <Breadcrumb.Item active>
                  <span className="text-dark fs-6">Departments</span>
                </Breadcrumb.Item>
              </Breadcrumb>
            </div>
          </Col>

          {/* RIGHT */}
          <Col
            md={6}
            sm={12}
            style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: "10px",
              marginTop: "10px",
              flexWrap: "wrap",
            }}
          >
            {/* EXPORT DROPDOWN */}
            <Dropdown>
              <Dropdown.Toggle
                style={{
                  background: "#fff",
                  border: "1px solid #e5e7eb",
                  color: "#111827",
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                }}
              >
                <FiFileText />
                Export
              </Dropdown.Toggle>

              <Dropdown.Menu style={{ padding: "8px" }}>
                <Dropdown.Item>
                  <HiOutlineDocumentText style={{ marginRight: "6px" }} />
                  Export as PDF
                </Dropdown.Item>
                <Dropdown.Item>
                  <HiOutlineDocumentText style={{ marginRight: "6px" }} />
                  Export as Excel
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>

            {/* ADD BUTTON */}
            <Button
              onClick={() => setShowModal(true)}
              style={{
                backgroundColor: "#f97316",
                border: "none",
                display: "flex",
                alignItems: "center",
                gap: "6px",
                padding: "8px 16px",
                borderRadius: "6px",
              }}
            >
              <FiPlusCircle />
              Add Department
            </Button>
          </Col>
        </Row>
      </div>

      {/* MODAL */}
      <AddDepartmentModal
        show={showModal}
        handleClose={() => setShowModal(false)}
      />
    </>
  );
};

export default DepartmentHeader;
